<div class="search-field-container">
  <ng-container *ngrxLet="query$; let query">
    <div class="input-field">
      <input
        #inputField
        pInputText
        type="text"
        (keydown)="search($event)"
        [ngModel]="query"
        (input)="queryInputChanged($event)"
        [pAutoFocus]="true"
        placeholder="Suchen"
        aria-label="Suchen"
        data-cy="main-search-input-field"
        />
        @if (!stringNullOrEmpty(query)) {
          <button data-no-search (click)="clearSearchInput()" data-cy="clear-main-search-input-field">
            <i class="pi pi-times" aria-label="Suchfeld löschen"></i>
          </button>
        }
        @if (stringNullOrEmpty(query)) {
          <i class="pi pi-search" style="font-size: 16px; color: #4e4d47"></i>
        }
      </div>
    </ng-container>
    <div class="filter-header">
      <div><h2 class="title">Suchen nach</h2></div>
      <div class="button-container">
        <button
          data-no-search
          pRipple
          type="button"
          title="Tipps zur Suche"
          class="p-filter-dialog-button"
          (click)="openInfoDialog($event)"
          >
          <img src="assets/icons/info.svg" alt="Informationen zu Sucheinstellungen"/>
        </button>
        <ng-container *ngrxLet="areProfileSettingsDefault$; let isDefault">
          @if (isDefault) {
            <button
              data-no-search
              pRipple
              type="button"
              title="Sucheinstellungen"
              class="p-filter-dialog-button"
              (click)="openProfileFiltersDialog($event)"
              >
              <img src="assets/icons/global-filter.svg" alt="Sucheinstellungen im Standardmodus"/>
            </button>
          }
          @if (!isDefault) {
            <button
              data-no-search
              pRipple
              type="button"
              title="Sucheinstellungen"
              class="p-filter-dialog-button"
              (click)="openProfileFiltersDialog($event)"
              >
              <img src="assets/icons/global-filter-selected.svg" alt="Sucheinstellungen eingeschränkt"/>
            </button>
          }
        </ng-container>
      </div>
    </div>
    <div class="toggle-container">
      <app-search-toggle></app-search-toggle>
    </div>
  </div>
